import Cookies from 'js-cookie'

const TokenKey = 'tms-spring-token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

// 自定义打开窗口， 传token
export function windowOpen1 (url) {
  const trimmedUrl = tmsSpringUrl.endsWith('/') ? tmsSpringUrl.slice(0, -1) : tmsSpringUrl;
  if(url.indexOf("?") == -1){
    window.open(trimmedUrl + url + "?token=" + getToken())
  }else {
    window.open(trimmedUrl + url + "&token=" + getToken())
  }
  
}



// WEBPACK FOOTER //
// ./src/util/auth.js